<div class="control"  (click)="toggleModal(); calculateItemsChecked();">
  <div class = "card-control-text">
    <span class="font-4 bold500">
      {{label}}
    </span>
    <span class="font-2">
      {{selectedItemsText}} selected
    </span>
  </div>
  <app-dropdown-icon class="suffix"></app-dropdown-icon>
  <app-popup-modal *ngIf="showCheckboxSelector"  class="green-scroll">
    <div class="checkbox-dropdown-body start-column-container column-gap-0p5 width-96pcnt" (click)="$event.stopPropagation();">
      <div *ngIf="props.isSelectAllEnabled" class="start-row-container upper-text-button font-3 bold500"
            (click)=" changeAllSelected(allValuesCheckedText); $event.stopPropagation();">
        {{allValuesCheckedText}}
      </div>
      <ng-container *ngFor="let checkBoxSelector of items">
        <div
          *ngIf="!checkBoxSelector.isHidden"
          class="start-row-container"
          (click)="$event.stopPropagation(); changeSelection(checkBoxSelector)">
          <app-checkbox (click)="$event.stopPropagation()" [checked]="checkBoxSelector.chosen" [disabled]="checkBoxSelector.disabled" (change)="changeSelection(checkBoxSelector)">
          </app-checkbox>
          <span class="font-3 bold500" [class.disabled]="checkBoxSelector.disabled">{{checkBoxSelector.item | linkShort: 35}}</span>
        </div>
      </ng-container>
    </div>
  </app-popup-modal>
</div>
